if (!window.senixWarrantyCartInitialized) {
  window.senixWarrantyCartInitialized = true;

  const refreshCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (document.body.classList.contains('template-cart')) {
      const currentCart = document.querySelector('#main-cart-items');
      const sectionId = currentCart?.dataset.id;
      if (!currentCart || !sectionId) return Promise.resolve();

      return fetch(`/cart?section_id=${encodeURIComponent(sectionId)}`)
        .then((response) => response.text())
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const updatedCart = documentFragment.querySelector('#main-cart-items');
          if (updatedCart) currentCart.replaceWith(updatedCart);
        });
    }

    const cartDrawer = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (!cartDrawer) return Promise.resolve();

    return fetch(`${window.routes.root}/cart?view=ajax_side_cart`)
      .then((response) => response.text())
      .then((html) => {
        if (window.jQuery) {
          window.jQuery(cartDrawer).html(html);
        } else {
          cartDrawer.innerHTML = html;
        }
      });
  };

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest('[data-cart-quantity]');
    const itemRow = quantityInput?.closest('[data-item-row]');
    if (!quantityInput || !itemRow || itemRow.dataset.parentLineKey) return;

    const parentLineKey = itemRow.dataset.lineKey;
    const relatedRows = Array.from(document.querySelectorAll('[data-item-row]')).filter((row) => {
      return row.dataset.lineKey === parentLineKey || row.dataset.parentLineKey === parentLineKey;
    });

    if (relatedRows.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const inventory = parseInt(quantityInput.dataset.inventoryQuantity || '', 10);
    let quantity = Math.max(0, parseInt(quantityInput.value || '0', 10) || 0);
    if (inventory > 0 && quantity > inventory) quantity = inventory;

    const updates = {};
    relatedRows.forEach((row) => {
      updates[row.dataset.lineKey] = quantity;
    });

    fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ updates })
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Warranty quantity update failed (${response.status}).`);
        return response.json();
      })
      .then((cart) => refreshCart(cart).then(() => {
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      }))
      .catch((error) => {
        quantityInput.value = quantityInput.defaultValue;
        window.alert('Unable to update the covered product quantity. Please try again.');
        console.error(error);
      });
  }, true);
}
